// extracted by mini-css-extract-plugin
export var discard = "_28-4";
export var muiTooltipTooltip = "_28-6";
export var notificationBar = "_28-3";
export var notificationContainer = "_28-2";
export var saveButtonHoverSlotWrapper = "_28-5";
export var show = "_28-1";
export var spacer = "_28-0";